module.exports = __webpack_public_path__ + "img/linksIndicatorActive.5916f964.png";